<style>
.slot-sec {
  overflow-y: auto !important;
}
#show-lable {
  display: inline-block;
  padding: 8px 25px;
  background: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin: 5px 0;
  font-size: 14px;
  font-weight: 600;
  color: rgb(0, 169, 130);
  border: 1px solid rgb(0, 169, 130);
  text-align: center;
  border-radius: 6px;
  width: 100%;
  min-height: 350px;
  max-height: 350px;
}
.attendee-details-popup#sp-attendee ul li {
  justify-content: center;
}
.calender-left.attendee-details-popup ul li {
  justify-content: center;
}
.timezone-textbox {
  position: absolute;
  z-index: 999;
  bottom: 0px;
  left: 2%;
  width: 300px;
  background: #e8e8e8;
  border-radius: 50px;
  height: 40px;
  padding-left: 42px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #242432;
  font-size: 14px;
}
.timezone-textbox select {
  width: 100%;
  height: 40px;
  border: none;
  padding: 0 15px 0 35px;
  border-radius: 50px;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-size: 15px;
  font-weight: 400;
  color: #000;
  background: url(../assets/Images/caret-down.svg) no-repeat right 15px center /
    15px;
  cursor: pointer;
  position: relative;
}
.timezone-textbox:before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  background: url(../assets/Images/globe.svg) no-repeat center center / 100%;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.timezone-textbox select:focus,
.timezone-textbox select:hover,
.timezone-textbox select:active {
  outline: none;
}
.disable-slot {
  border-color: #f1f1f1 !important;
  background: #f1f1f1 !important;
  color: #ccc !important;
  cursor: no-drop !important;
}
.requestmeetingmodal {
  min-width: 600px;
  min-height: 400px;
}
#calendarModal .success {
  background-color: transparent !important;
  border-color: transparent !important;
}
.enter-details-form .form-wrapper input[type="text"],
.enter-details-form .form-wrapper input[type="email"] {
  color: #afafaf;
  border: none !important;
  padding: 0 !important;
  height: inherit !important;
}

.select-box .filter-group {
  font-weight: 500;
  font-size: 16px;
  position: relative;
  /*margin-bottom: 30px;*/
  margin: 5px 0;
  cursor: pointer;
}
.select-box .filter-group[aria-expanded="true"]:after {
  transform: translateY(-50%) rotate(180deg);
  transition: 0.2s;
}

.select-box .filter-group:after {
  position: absolute;
  background-image: url("../assets/Images/arrow-icon.svg");
  content: "";
  right: 0;
  left: auto;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  transition: 0.2s;
}
.meeting-request .deg {
  margin-bottom: 10px;
}
.meeting-request .deg:before {
  background: url(../assets/Images/icons/designation.png) no-repeat 0px center;
  content: "";
  background-size: 20px;
  height: 15px;
  width: 35px;
  padding-left: 35px;
}
.meeting-request .top-img-box .full-width {
  margin-bottom: 0;
}
.meeting-request .contact-details {
  padding-bottom: 5px;
  margin-bottom: 5px;
}
.meeting-request .contact-details ul li a {
  margin-top: 2px;
}
.attendee-details-popup .top-img-box {
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.local-time-zone {
  text-align: center;
  color: #8b8b8b;
  margin-top: 20px;
}
.local-time-zone:before {
  content: "\f0ac";
  font: normal normal normal 16px/1 FontAwesome;
  height: 15px;
  width: 15px;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  color: #919297;
  padding-right: 5px;
}
.request-meet-calendar
  .datepicker-container-label
  span
  button
  > span.custom-button-content.flex {
  flex: 0 !important;
  max-width: 100%;
}
.request-meet-calendar .datepicker-container-label span {
  flex: 0 !important;
}
.request-meet-calendar .datepicker-container-label {
  margin-left: 0 !important;
}
.request-meet-calendar .datepicker-container-label button.custom-button {
  background: none !important;
}
.request-meet-calendar .year-month-selector button.custom-button {
  padding: 5px 8px !important;
  background: none !important;
}
.request-meet-calendar .year-month-selector button.custom-button.with-border {
  border-color: transparent;
}
.request-meet-calendar .year-month-selector .flex {
  flex: 0 !important;
}
.request-meet-calendar .year-month-selector .justify-content-right {
  justify-content: center !important;
}
.country-selector {
  min-height: 43px !important;
  height: 43px !important;
}
@media only screen and (max-width: 767px) {
  .meeting-request .calendar-wrap {
    margin-top: 0px !important;
  }
}
</style>
<template class="page-effect">
  <!---calander start 9.06.2020----->
  <div
    id="calendarModal"
    class="modal fade custom-modal-container calendar-popup"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog xl" role="document">
      <div class="modal-content requestmeetingmodal">
        <div class="modal-body pr-1 pb-4">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            v-on:click="clearModal()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#242432"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </button>

          <div class="row m-0 meeting-request">
            <div
              class="
                col-lg-4 col-md-12
                attendee-details-popup attendee-list
                calender-left
                pl-0
                pt-0
              "
            >
              <!----left side-->
              <div class="sponsors-box-hld justify-content-start">
                <!-- <div class="top-img-box full-width">
                  <span class="attendee-img-area" v-if="Userlists.userImage != ''">
                    <img v-bind:src="Userlists.userImage" v-bind:alt="Userlists.userName" />
                  </span>
                  <span class="attendee-img-area" v-else>
                    <img src="../assets/Images/imgpsh_fullsize_anim.jpg" alt="e2m" />
                  </span>
                  <div class="grey-bg-texthld">
                    <h3>{{ Userlists.userName }}</h3>
                    <h4>{{ Userlists.userTitle }}</h4>
                  </div>
                </div>
                <div class="or mb-3">
                  <span></span>
                </div>-->
                <div class="top-img-box full-width">
                  <!-- <span class="attendee-img-area" v-if="Image != ''"> -->
                  <span class="attendee-img-area">
                    <!--<img
                      id="ReqAttendeeImage"
                      src="../assets/Images/imgpsh_fullsize_anim.jpg"
                      alt="e2m"
                    />-->
                    <img
                      v-if="attendee && attendee.ProfilePictureURL"
                      id="ReqAttendeeImage"
                      :src="attendee.ProfilePictureURL"
                      @error="attendee.ProfilePictureURL = ''"
                    />

                    <!--<div id="ReqdivImgHldText" class="attendee-img-hld mx-auto">
                      <img id="ReqImgModalAttendee" class="imguserthumb" />
                    </div>-->

                    <div
                      v-else
                      id="ReqdivImgHldText"
                      class="attendee-img-hld mx-auto"
                    >
                      <h4 v-if="attendee && attendee.Initials">
                        {{
                          attendee && attendee.Initials ? attendee.Initials : ""
                        }}
                      </h4>
                      <h4
                        v-if="attendee && !attendee.Initials && attendee.Name"
                      >
                        {{ getInitials(attendee.Name) }}
                      </h4>
                    </div>
                  </span>
                  <!--<span class="attendee-img-area" v-else> -->
                  <!-- <img src="../assets/Images/imgpsh_fullsize_anim.jpg" alt="e2m" />-->
                  <!-- </span> -->
                  <div class="grey-bg-texthld mt-2">
                    <h3 id="ReqAttendeeName">
                      {{ attendee && attendee.Name ? attendee.Name : "" }}
                    </h3>
                    <h4
                      v-show="attendee && attendee.Company"
                      id="ReqAttendeeCompany"
                      class="attendee-company-name"
                    >
                      {{ attendee && attendee.Company ? attendee.Company : "" }}
                    </h4>
                    <h4
                      v-show="attendee && attendee.Designation"
                      id="ReqAttendeeTitle"
                      class="attendee-company-title"
                    >
                      {{
                        attendee && attendee.Designation
                          ? attendee.Designation
                          : ""
                      }}
                    </h4>
                  </div>
                  <div class="popup-social-area d-none">
                    <ul class="m-0 p-0">
                      <li>
                        <a target="_blank" id="aFacebok" href>
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a target="_blank" id="aTwitter" href>
                          <i class="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a target="_blank" id="aLikedin" href>
                          <i class="fa fa-linkedin"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-------contact details---->
                <div
                  class="contact-details"
                  style="width: 100%; margin-bottom: 10px"
                >

                
                  <ul class="p-0 m-0">
                    <li v-show="attendee && attendee.Email" class="email">
                      <a
                        style="color: #000"
                        :href="'mailto:'+attendee.Email"
                        id="ReqAttendeeEmail"
                        >{{
                          attendee && attendee.Email ? attendee.Email : ""
                        }}</a
                      >
                    </li>
                    <li v-show="attendee && attendee.Phone" class="ph-no">
                      <a
                        target="_blank"
                        style="color: #000"
                        :href="'tel:'+attendee.Phone"
                        id="ReqAttendeePhone"
                        >{{
                          attendee && attendee.Phone ? attendee.Phone : ""
                        }}</a
                      >
                    </li>
                    <li v-show="attendee && attendee.Website" class="website">
                      <a
                        target="_blank"
                        style="color: #000"
                        :href="attendee.Website"
                        id="ReqAttendeeWebsite"
                        >{{
                          attendee && attendee.Website ? attendee.Website : ""
                        }}</a
                      >
                    </li>
                  </ul>

                </div>
                <!-------contact details---->
                <!--v-if="attendee"-->
                <div
                  v-show="attendee && (getRegistrationType || getDynamicHTML)"
                  class="select-box"
                  style="text-align: left; border: 0px"
                >
                  <h5 href="#requestMeetingAttendeeDetails">
                    {{ $t("mymeetings.moreinformation") }}
                  </h5>
                  <div
                    id="requestMeetingAttendeeDetails"
                    class="language-box filter-group-content"
                    style="
                      max-height: 130px;
                      overflow-y: auto;
                      word-break: break-word;
                    "
                  >
                    <div v-if="getRegistrationType" class="text-justify deg">
                      {{ getRegistrationType }}
                    </div>
                    <div v-if="getProfile" class="" v-html="getProfile"></div>
                    <div v-html="getDynamicHTML"></div>
                  </div>
                </div>
                <div v-show="false && !morInfoVisible">
                  <p>
                    {{ $t("mymeetings.lblmsg") }}
                  </p>
                  <p class="mb-1">{{ $t("mymeetings.thanks") }},</p>
                  <h4 id="ReqAttendeeNameh4" class="attendee-bottom-name"></h4>
                  <!-- <div class="contact-info">
                  <ul class="p-0">
                    <li v-if="Email">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="25px"
                        height="19px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="#5d5c5c"
                          d="M0.001,18.999 L0.001,0.011 L25.007,0.011 L25.007,18.999 L0.001,18.999 ZM2.000,17.000 L7.000,10.000 L2.000,4.000 L2.000,17.000 ZM2.000,2.000 L11.000,11.000 C12.052,11.950 13.390,11.687 14.000,11.000 L23.000,2.000 L2.000,2.000 ZM22.000,17.000 L17.000,11.000 C15.024,12.994 14.356,13.000 13.000,13.000 C11.646,13.000 9.976,12.994 8.000,11.000 L4.000,17.000 L22.000,17.000 ZM18.000,10.000 L23.000,16.000 L23.000,4.000 L18.000,10.000 Z"
                        />
                      </svg>

                      <span>
                        <a v-bind:href="'mailto:' + Email">{{Email}}</a>
                      </span>
                    </li>
                    <li v-if="Phone">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="34px"
                        height="34px"
                      >
                        <path
                          fill-rule="evenodd"
                          fill="#5d5c5c"
                          d="M23.631,19.889 C23.595,19.792 23.370,19.651 22.954,19.463 C22.841,19.404 22.681,19.324 22.474,19.222 C22.266,19.121 22.077,19.027 21.908,18.941 C21.739,18.856 21.580,18.773 21.432,18.692 C21.408,18.676 21.334,18.630 21.209,18.552 C21.085,18.474 20.979,18.417 20.893,18.379 C20.807,18.342 20.723,18.323 20.639,18.323 C20.521,18.323 20.372,18.399 20.194,18.552 C20.016,18.704 19.853,18.870 19.705,19.050 C19.556,19.229 19.399,19.395 19.233,19.547 C19.067,19.700 18.930,19.776 18.823,19.776 C18.770,19.776 18.703,19.763 18.623,19.736 C18.543,19.709 18.482,19.687 18.440,19.668 C18.399,19.649 18.328,19.612 18.227,19.555 C18.126,19.499 18.069,19.469 18.058,19.463 C17.244,19.056 16.547,18.591 15.965,18.066 C15.384,17.542 14.867,16.913 14.416,16.179 C14.410,16.169 14.376,16.118 14.314,16.027 C14.251,15.936 14.210,15.872 14.189,15.834 C14.168,15.797 14.143,15.742 14.113,15.670 C14.084,15.597 14.069,15.537 14.069,15.489 C14.069,15.393 14.153,15.269 14.323,15.120 C14.492,14.970 14.676,14.828 14.875,14.694 C15.073,14.560 15.257,14.413 15.427,14.252 C15.596,14.092 15.680,13.958 15.680,13.851 C15.680,13.776 15.660,13.700 15.618,13.622 C15.576,13.545 15.513,13.450 15.427,13.337 C15.341,13.225 15.289,13.158 15.271,13.136 C15.182,13.003 15.090,12.859 14.995,12.707 C14.900,12.554 14.796,12.384 14.683,12.197 C14.570,12.010 14.481,11.865 14.416,11.764 C14.208,11.389 14.051,11.185 13.944,11.153 C13.903,11.137 13.840,11.129 13.757,11.129 C13.597,11.129 13.388,11.156 13.130,11.210 C12.871,11.263 12.668,11.319 12.520,11.378 C12.223,11.491 11.908,11.817 11.576,12.358 C11.273,12.861 11.122,13.359 11.122,13.851 C11.122,13.996 11.132,14.136 11.153,14.273 C11.174,14.409 11.211,14.563 11.264,14.734 C11.318,14.906 11.361,15.033 11.393,15.116 C11.426,15.199 11.487,15.347 11.576,15.561 C11.665,15.775 11.718,15.906 11.736,15.955 C11.944,16.479 12.190,16.948 12.475,17.360 C12.944,18.045 13.584,18.753 14.394,19.483 C15.204,20.214 15.989,20.791 16.749,21.213 C17.206,21.470 17.725,21.693 18.307,21.880 C18.360,21.896 18.506,21.944 18.743,22.024 C18.980,22.105 19.145,22.160 19.237,22.189 C19.329,22.218 19.470,22.257 19.660,22.305 C19.850,22.354 20.021,22.387 20.172,22.406 C20.323,22.425 20.479,22.434 20.639,22.434 C21.185,22.434 21.737,22.297 22.295,22.024 C22.895,21.725 23.257,21.441 23.382,21.173 C23.447,21.040 23.509,20.856 23.569,20.623 C23.628,20.390 23.658,20.202 23.658,20.057 C23.658,19.982 23.649,19.926 23.631,19.889 L23.631,19.889 Z"
                        />
                        <path
                          fill-rule="evenodd"
                          stroke-width="2px"
                          stroke="rgb(36, 36, 50)"
                          fill-opacity="0"
                          fill="rgb(3, 97, 159)"
                          d="M17.000,5.000 C23.627,5.000 29.000,10.373 29.000,17.000 C29.000,23.627 23.627,29.000 17.000,29.000 C10.373,29.000 5.000,23.627 5.000,17.000 C5.000,10.373 10.373,5.000 17.000,5.000 Z"
                        />
                      </svg>
                      <span>
                        <a v-bind:href="'tel:' + Phone">{{Phone}}</a>
                      </span>
                    </li>
                  </ul>
                </div>-->
                </div>
              </div>
              <!----left side end-->
            </div>
            <div
              :class="
                showDatePicker == true
                  ? 'col-lg-12 col-md-12 page-effect'
                  : 'col-lg-8 col-md-12 page-effect'
              "
            >
              <div class="modal-body-wrapper">
                <div class="calendar-wrap">
                  <div class="modal-body-head calender-head">
                    <h5>{{ $t("mymeetings.selectdateandtime") }}</h5>
                    <h4 class="mb-0" id="hdrSelectDate"></h4>
                  </div>
                  <div class="calendar-sec request-meet-calendar">
                    <div id="calendar" class="calender-hld">
                      <div id="caldiv">
                        <VueCtkDateTimePicker
                          v-model="date"
                          color="#00a982"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :only-date="true"
                          :no-button="true"
                          :disabled-dates="disabledDates"
                        />
                      </div>
                    </div>
                    <div class="timing-wrap d-flex flex-column page-effect">
                      <div class="time-legend pb-2 mb-2">
                        <ul class="p-0 d-flex">
                          <li class="available-time page-effect">
                            <h4>
                              <!--{{ $t("mymeetings.selecttime") }}-->
                              <span
                                >{{ $t("mymeetings.duration") }} {{ duration }}
                                {{ $t("mymeetings.min") }}</span
                              >
                            </h4>
                            <p>{{ $t("mymeetings.scrollforslots") }}</p>
                          </li>
                        </ul>
                      </div>

                      <div class="d-flex page-effect slot-sec">
                        <div id="show-lable">
                          {{ $t("mymeetings.chooseSlotTxt") }}
                        </div>
                        <ul
                          id="slotUL"
                          class="page-effect"
                          style="display: none"
                        >
                          <!-- <li v-for="SlotTime in availableSlot" v-bind:key="SlotTime">
            <button class="active_time" @click="OpenMeetingDetails(SlotTime)">{{SlotTime}}</button>
                          </li>-->

                          <!-- <li v-for="SlotTime in SlotAvailable" v-bind:key="SlotTime">
            <button class="active_time" @click="OpenMeetingDetails(SlotTime)">{{SlotTime}}</button>
                          </li>-->
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h6 class="local-time-zone">
                      {{ localTimeZone }}
                    </h6>
                  </div>
                  <!-- <div class="timezone-textbox" id="dvEventTimeZone">
                    {{ $t("mymeetings.eventtimezone") }} (06:58pm)
                  </div> -->
                </div>
                <div class="modal-body-wrapper2" style="display: none">
                  <!--  -->
                  <div class="modal-body-head">
                    <h4 class="text-left mb-4">
                      {{ $t("mymeetings.sendmeetingrequest") }}
                    </h4>
                  </div>
                  <div class="modal-body-head2 mt-3 position-relative">
                    <ul class="p-0">
                      <li class="displayDate"></li>
                      <li>
                        {{ duration }}
                        {{ $t("mymeetings.min") }}
                      </li>
                      <li style="display: none">
                        {{ $t("mymeetings.utctime") }}
                      </li>
                    </ul>
                    <button class="edit-time" @click="EditTime()">
                      {{ $t("mymeetings.edit") }}
                    </button>
                  </div>
                  <div class="enter-details-form">
                    <div class="form-wrapper">
                      <div class="row">
                        <div class="col-md-12 mt-8 py-0">
                          <h4 class="mt-0">
                            {{ $t("mymeetings.enterdetails") }}
                          </h4>
                        </div>
                        <!-- <div class="col-md-6 ">
                          <input
                            type="text"
                            name="txtname"
                            id="txtname"
                            v-bind:value="Userlists.userName"
                            placeholder="Name"
                          />
                          <p
                            class="errtxt"
                            id="ErrEnterName"
                            style="display: none"
                          >
                            {{ $t("mymeetings.entername") }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <input
                            type="email"
                            name="txtemail"
                            id="txtemail"
                            v-bind:value="Userlists.userEmail"
                            placeholder="Email"
                          />
                          <p
                            class="errtxt"
                            id="ErrEnterEmail"
                            style="display: none"
                          >
                            {{ $t("mymeetings.enteremail") }}
                          </p>
                        </div> -->
                        <div class="col-md-12">
                          <div>
                            <!-- <select>
                              <option>+91</option>
                            </select>
                            <input
                              type="tel"
                              name="txtPhone"
                              id="txtPhone"
                              v-bind:value="Userlists.userPhone"
                            /> -->
                            <VuePhoneNumberInput
                              id="txtPhone"
                              v-model="phoneNo"
                              :preferredCountries="['US', 'GB', 'SG', 'IN']"
                              @update="showPayload"
                            />
                          </div>
                          <p
                            class="errtxt"
                            id="ErrEnterPhone"
                            style="display: none"
                          >
                            {{ $t("mymeetings.enterphone") }}
                          </p>
                        </div>
                        <div class="col-md-12 pb-4">
                          <textarea
                            id="MeetingPurpose"
                            class="mb-0"
                            rows="40"
                            :placeholder="$t('mymeetings.purposeofmeeting')"
                          ></textarea>
                        </div>
                        <div class="col-md-12 py-0">
                          <h4 class="mt-0">Your Info</h4>
                        </div>
                        <div class="col-md-6 pt-0">
                          <input
                            type="text"
                            name="txtname"
                            id="txtname"
                            v-bind:value="Userlists.userName"
                            placeholder="Name"
                          />
                          <p
                            class="errtxt"
                            id="ErrEnterName"
                            style="display: none"
                          >
                            {{ $t("mymeetings.entername") }}
                          </p>
                        </div>
                        <div class="col-md-6 pt-0">
                          <input
                            type="email"
                            name="txtemail"
                            id="txtemail"
                            v-bind:value="Userlists.userEmail"
                            placeholder="Email"
                          />
                          <p
                            class="errtxt"
                            id="ErrEnterEmail"
                            style="display: none"
                          >
                            {{ $t("mymeetings.enteremail") }}
                          </p>
                        </div>
                      </div>
                      <input type="hidden" id="hdnSelectedDate" />
                      <input type="hidden" id="hdnSelectedSlot" />
                      <div class="text-right mt-1">
                        <button
                          id="btnSendRequest"
                          style="font-weight: bold"
                          class="btn-rounder request-meeting"
                          @click="RequestMeeting()"
                        >
                          {{ $t("mymeetings.sendrequest") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-body-wrapper3" style="display: none">
                  <!--   -->
                  <div class="modal-body-head">
                    <h4 class="text-left mb-4 ml-4">
                      {{ $t("mymeetings.meetingconfirmation") }}
                    </h4>
                  </div>
                  <div class="text-center">
                    <!-- <p>
                      <img
                        src="../assets/Images/icons/meeting-success.jpg"
                        alt="success"
                        width="90px"
                      />
                    </p> -->
                    <div class="meeting-success"></div>
                    <h5>{{ $t("mymeetings.yourmeetingrequestsent") }}</h5>
                  </div>
                  <div class="confirmation-details">
                    <div class="modal-body-head2 mt-3 position-relative">
                      <ul class="p-0">
                        <li class="displayDate">
                          <span></span>
                        </li>
                        <li>
                          {{ duration }}
                          {{ $t("mymeetings.min") }}
                        </li>
                        <li style="display: none">
                          {{ $t("mymeetings.utctime") }}
                        </li>
                      </ul>
                      <br />
                      <span class="text-center mt-1">{{
                        $t("mymeetings.ifyoudontrcvrequest")
                      }}</span>
                    </div>

                    <div class="text-center mt-1">
                      <!-- <button
                        class="btn-rounder my-meeting request-meeting"
                        
                      >
                        
                      </button> -->
                      <v-btn
                        class="mt-3 my-meeting request-meeting"
                        shaped
                        dark
                        color="#1a73e8"
                        v-on:click="navigate"
                      >
                        <span class="mr-3"
                          ><img
                            src="../assets/Images/icons/meeting-icon.svg"
                            style="height: 25px; width: 20px"
                        /></span>
                        {{ $t("mymeetings.mymeeting") }}
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------->
</template>


<script>
import db from "../components/firebaseInit";
import VueCtkDateTimePicker from "./../VueCtkDateTimePicker";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
//import moment from "moment";
import moment from "moment-timezone";
import axios from "axios";
import APIs from "@/components/APIInit";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import common from "@/common";

//import store from "../store";
//let obj = JSON.parse(window.localStorage.getItem("my-app"));
let self;

export default {
  name: "ReqMeeting",
  components: {
    VueCtkDateTimePicker,
    VuePhoneNumberInput,
  },
  props: {
    attendeeId: String,
    attendee: {
      type: Object,
      default: null,
      required: false,
    },
    showDatePicker: Boolean,
  },
  data() {
    var MeetingStartDate = new Date();
    var MeetingEndDate = new Date();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (
      obj.MeetingSettings[0].Items &&
      obj.MeetingSettings[0].Items.length > 1
    ) {
      let dtStart = new Date(
        obj.MeetingSettings[0].Items[0].MeetingStartTimestampUTC
      );

      let dtCurrentYear = dtStart.getFullYear();
      let dtCurrentMonth = dtStart.getMonth();
      let dtCurrentDay = dtStart.getDate();
      MeetingStartDate = new Date(dtCurrentYear, dtCurrentMonth, dtCurrentDay);
      // alert("CurrentDate :" + this.formatDate(CurrentDt));

      let dtEnd = new Date(
        obj.MeetingSettings[0].Items[
          obj.MeetingSettings[0].Items.length - 1
        ].MeetingEndTimestampUTC
      );
      var dtEndYear = dtEnd.getFullYear();
      var dtEndMonth = dtEnd.getMonth();
      var dtEndDay = dtEnd.getDate();
      MeetingEndDate = new Date(dtEndYear, dtEndMonth, dtEndDay);
      // alert("eventEndDate :" + this.formatDate(MeetingEndDate));
    } else {
      let dtStart = new Date(obj.MeetingSettings[0].StartDate._seconds * 1000);
      let dtStartYear = dtStart.getFullYear();
      let dtStartMonth = dtStart.getMonth();
      let dtStartDay = dtStart.getDate();
      MeetingStartDate = new Date(dtStartYear, dtStartMonth, dtStartDay);
      // alert("CurrentDate :" + this.formatDate(CurrentDt));

      let dtEnd = new Date(obj.MeetingSettings[0].EndDate._seconds * 1000);
      let dtEndYear = dtEnd.getFullYear();
      let dtEndMonth = dtEnd.getMonth();
      let dtEndDay = dtEnd.getDate();
      MeetingEndDate = new Date(dtEndYear, dtEndMonth, dtEndDay);
      // alert("eventEndDate :" + this.formatDate(MeetingEndDate));
    }
    return {
      date: new Date(),
      //minDate: '2020-06-03',
      //maxDate: '2020-06-30',
      minDate: this.formatDate(MeetingStartDate),
      maxDate: this.formatDate(MeetingEndDate),
      EmailURL: "https://awsapi.e2m.live/send-email",
      disabledDates: [],
      SlotAvailable: [],
      FCMURL: "https://fcm.googleapis.com/fcm/send",
      APIs: APIs,
      sendAttendeeId: this.attendeeId,
      phoneNo: null,
      formatedPhoneNo: null,
      clientId: "",
      eventId: "",
      morInfoVisible: false,
      attendeeProfile: "",
      attendeeRegType: "",
      attendeeDynamicFields: "",
      localTimeZone: "",
      duration: "",
    };
  },
  computed: {
    Userlists() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        userName: obj.user[0].name,
        userImage: obj.user[0].profilepic,
        userEmail: obj.user[0].Email,
        userPhone: obj.user[0].Phone,
        userTitle: obj.user[0].Title,
      };
    },
    MeetingSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        Slot: obj.MeetingSettings[0].Slot,
        StartDate: obj.MeetingSettings[0].StartDate,
        EndDate: obj.MeetingSettings[0].EndDate,
        AvailabilityFromTime: obj.MeetingSettings[0].AvailabilityFromTime,
        AvailabilityToTime: obj.MeetingSettings[0].AvailabilityToTime,
        ByTimezone: obj.MeetingSettings[0].ByTimezone,
        Duration: obj.MeetingSettings[0].Duration,
      };
    },
    // MeetingSlots() {
    //   var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //   return {
    //     SlotTime: obj.AvailableSlots[0].SlotTime,
    //   };
    // },
    getRegistrationType() {
      if (
        self.StaticFieldsExcludeOptions &&
        self.StaticFieldsExcludeOptions.RegistrationType == false
      ) {
        return "";
      } else {
        return this.attendee &&
          typeof this.attendee.RegistrationType == "object"
          ? this.attendee.RegistrationType.RegistrationType
          : this.attendee && this.attendee.RegistrationType
          ? this.attendee.RegistrationType
          : "";
      }
    },
    getProfile() {
      if (this.attendee && this.attendee.Profile) {
        return this.attendee.Profile;
      } else {
        return "";
      }
    },
    getDynamicHTML() {
      var dynamicContent = "";
      //var inicr = 0;
      var DynamicFields = [];
      if (this.attendee && this.attendee.DynamicFields) {
        DynamicFields = this.attendee.DynamicFields;
      }
      if (DynamicFields) {
        DynamicFields = self.attendeeDynamicFields;
      }
      //self.attendeeProfile = data.Profile;
      //self.attendeeRegType = data.RegistrationType;
      if (DynamicFields) {
        let maxIndex = 0;
        $.each(DynamicFields, function (k1, v1) {
          if (v1.index > maxIndex) {
            maxIndex = v1.index;
          }
        });
        for (var index = 0; index <= maxIndex; index++) {
          Object.keys(DynamicFields).forEach(function (k) {
            let v = DynamicFields[k];
            if (index == v.index) {
              let displayField = true;
              if (
                self.DynamicFieldsExcludeOptions &&
                self.DynamicFieldsExcludeOptions.includes(k.toString())
              ) {
                displayField = false;
              }
              if (displayField) {
                if (v.field_type == "radio") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }

                if (v.field_type == "checkboxes") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
                if (v.field_type == "text") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
                if (v.field_type == "dropdown") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
                if (v.field_type == "email") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
                if (v.field_type == "paragraph") {
                  dynamicContent =
                    dynamicContent +
                    "<div class='edit-panel-cvr'><div><p><strong>" +
                    v.label +
                    "</strong><strong>:</strong></p><p><span>" +
                    v.value +
                    "</span></p></div></div>";
                }
              }
            }
          });
        }
      }
      return dynamicContent;
    },
  },
  watch: {
    //requestMeetingKey() {
    //  alert("attendeeId Changed");
    //  $(".modal-dialog.xl").removeClass("success");
    //},
    //"attendee.attendeeId"(val) {
    //  //alert("watch: " + val);
    //  //self.LoadAttendeeDetails(val);
    //},
  },
  created() {
    self = this;
    self.localTimeZone = common.getTimeZoneName();
  },
  // beforeMount() {
  //  self = this;

  //
  // },
  mounted() {
    self = this;
    $(".modal-dialog.xl").removeClass("success");
    $(".modal-body-wrapper2").hide();
    $(".modal-body-wrapper3").hide();
    $("#slotUL").hide();
    //setTimeout(() => {
    //self.LoadAttendeeDetails(self.attendee.attendeeId);
    //alert("attendeeId: " + self.attendeeId);
    //alert("mounted: " + self.attendee.attendeeId);
    if (self.attendee) {
      if (self.attendee.id) {
        //alert("mounted id: " + self.attendee.id);
        self.LoadAttendeeDetails(self.attendee.id);
      } else if (self.attendee.AttendeeId) {
        //alert("mounted AttendeeId: " + self.attendee.AttendeeId);
        self.LoadAttendeeDetails(self.attendee.AttendeeId);
      } else if (self.attendee.attendeeId) {
        //alert("mounted attendeeId: " + self.attendee.attendeeId);
        self.LoadAttendeeDetails(self.attendee.attendeeId);
      }
    }
    //}, 5000);
    self.setFirebaseAppsettings();
    //$("#selDate").hide();
    $(".calendar-wrap").show();
    $(".modal-body-wrapper2").hide();
    $(".modal-body-wrapper3").hide();

    //self.createAvailableMeetingSlots();

    var MSobj = JSON.parse(window.localStorage.getItem("my-app"));

    if (MSobj != undefined && MSobj != null) {
      this.clientId = MSobj.client[0].id;
      this.eventId = MSobj.eventid;
    }
    var MeetingStartDate = new Date();

    //var MeetingEndDate = new Date();

    if (MSobj.MeetingSettings.length > 0) {
      if (MSobj.MeetingSettings[0].StartDate !== undefined);
      {
        if (MSobj.MeetingSettings[0] != []) {
          MeetingStartDate = new Date(
            MSobj.MeetingSettings[0].StartDate._seconds * 1000
          );
        }
      }
      if (MSobj.MeetingSettings[0].Duration);
      {
        self.duration = MSobj.MeetingSettings[0].Duration;
      }
    }

    self.SlotAvailable = [];
    //MeetingStartDate = new Date(MSobj.MeetingSettings[0].StartDate._seconds * 1000);
    //alert("duration:" + self.duration);
    //alert(
    //  "MeetingStartDate:" +
    //    moment(MeetingStartDate).format("dddd, MMM DD, YYYY")
    //);
    $("#hdrSelectDate").html(
      moment(MeetingStartDate).format("dddd, MMM DD, YYYY")
    );

    self.fetchSlots(MeetingStartDate);
    //self.getAvailableMeetingSlots(MeetingStartDate);
    //self.fetchSlots();
    $("#btnSendRequest").text("Send Request");
    $("#btnSendRequest").attr("disabled", false);
  },

  methods: {
    checkDate: function (SelectedDt, time) {
      var startTime = moment(new Date(), "DD-MM-YYYY HH:mm A");
      var onlyDate = moment(SelectedDt, "DD-MM-YYYY").format("DD-MM-YYYY");
      var endTime = moment(onlyDate + " " + time, "DD-MM-YYYY HH:mm A");

      return endTime.isAfter(startTime);
    },
    EditTime: function () {
      // $("#ReqMeeting" + this.ReqIndex + " .calendar-wrap").show();
      // $("#ReqMeeting" + this.ReqIndex + " .modal-body-wrapper2").hide();
      // $("#ReqMeeting" + this.ReqIndex + " .modal-body-wrapper3").hide();

      $(" .calendar-wrap").show();
      $(" .modal-body-wrapper2").hide();
      $(" .modal-body-wrapper3").hide();
    },

    navigate() {
      $(".calendar-popup").modal("hide");
      $(".modal-body-wrapper2").hide();
      router.push({ name: "MyMeetings" });
    },

    OpenMeetingDetails(SelectedDate, selectedSlot) {
      //alert(SelectedDate);
      // alert(selectedSlot);

      //var SelectedDate = $("#hdnSelectedDate").val;

      var selectedSlotData = selectedSlot.split(":");
      var selectedhour = parseInt(selectedSlotData[0]);
      var selectedmin = parseInt(selectedSlotData[1]);

      if (selectedSlotData[1].indexOf("PM") >= 0 && selectedhour < 12) {
        selectedhour += 12;
      }

      if (selectedSlotData[1].indexOf("AM") >= 0 && selectedhour == 12) {
        selectedhour = 0;
      }

      var dtSelectedDate = new Date(SelectedDate);
      dtSelectedDate.setHours(selectedhour);
      dtSelectedDate.setMinutes(selectedmin);

      if (dtSelectedDate != "") {
        var SelDate = moment(new Date(dtSelectedDate)).format(
          "YYYY-MM-DDTHH:mm:ss+Z"
        );
        console.log(SelDate);
        $(".SeldtError").hide();
        $(".displayDate").html(
          moment(dtSelectedDate).utc().format("DD-MMM-YYYY hh:mm A")
        );

        $("#hdnSelectedDate").val(dtSelectedDate);
        $("#hdnSelectedSlot").val(selectedhour + "." + selectedmin);
        //alert(dtSelectedDate);
        $(".calendar-wrap").hide();
        $(".modal-body-wrapper2").show();
      } else {
        alert(self.$t("mymeetings.pleaseselectdate"));
        $(".SeldtError").show();
      }
    },
    MeetingConfirm: function () {
      var attendeeId = $("#hdnAttendeeId").val();
      $("#btnSendRequest").attr("disabled", true);
      $("#btnSendRequest").text("Sending Request");

      var attendeeName = document.getElementById("ReqAttendeeName").innerText;
      var Company = document.getElementById("ReqAttendeeCompany").innerText;
      var Title = document.getElementById("ReqAttendeeTitle").innerText;
      var Email = document.getElementById("ReqAttendeeEmail").innerText;
      var Phone = document.getElementById("ReqAttendeePhone").innerText;
      var Initials = document
        .getElementById("ReqdivImgHldText")
        .innerHTML.replace("<h4>", "")
        .replace("</h4>", "");

      if (
        document.getElementById("ReqAttendeeImage") != null &&
        document.getElementById("ReqAttendeeImage") != ""
      ) {
        var Image = document
          .getElementById("ReqAttendeeImage")
          .getAttribute("src");
      }

      var MeetingType = "Attendee";

      var chkValid = true;

      var txtname = $("#txtname").val();
      if (txtname == "") {
        alert(self.$t("mymeetings.pleaseentername"));
        $(".ErrEnterName").show();
        chkValid = false;
      }

      var txtemail = $("#txtemail").val();
      if (txtemail == "") {
        alert(self.$t("mymeetings.pleaseenteremail"));
        $(".ErrEnterEmail").show();
        chkValid = false;
      }
      var MeetingPurpose = $("#MeetingPurpose").val();

      if (chkValid) {
        var SelDateTime = $("#hdnSelectedDate").val();
        var obj = JSON.parse(window.localStorage.getItem("my-app"));

        var dtStartDateTime = new Date(SelDateTime);

        // dtStartDateTime = self.GetTimeByZone(dtStartDateTime, obj.tzone);
        var MeetingStartDate = moment(dtStartDateTime, ["h:mm A"]);
        MeetingStartDate = new Date(MeetingStartDate);

        var MeetingEndDate = moment(dtStartDateTime, ["h:mm A"]).add(
          self.MeetingSettings.Slot,
          "minutes"
        );
        MeetingEndDate = new Date(MeetingEndDate);
        //MeetingStartDate = this.GetTimeByZone(MeetingStartDate, obj.TimeZone);

        var MeetingId =
          "M_" + attendeeName.replace(" ", "") + "_" + new Date().getTime();

        var docRef = db
          .collection(obj.eventcollectionname)
          .doc("MeetingList")
          .collection("Meetings")
          .doc(MeetingId);
        docRef
          .get()
          .then(function (doc) {
            if (!doc.exists) {
              //

              var docObj = new Object();
              docObj.MeetingId = MeetingId;
              docObj.MeetingType = MeetingType;
              docObj.AttendeeId = attendeeId;
              docObj.AttendeeName = attendeeName;
              docObj.Initials = Initials;
              docObj.Company = Company;
              docObj.Title = Title;
              docObj.AttendeeEmail = Email;
              docObj.AttendeePhone = Phone;
              docObj.AttendeeImage = Image;
              docObj.OrganizerAttendees = obj.user[0];
              docObj.Subject = "One to One Meeting with " + obj.user[0].name;
              docObj.location = "";
              docObj.StartDateTime = MeetingStartDate;
              docObj.EndDateTime = MeetingEndDate;
              docObj.Message = MeetingPurpose;
              docObj.Status = "Request Sent";
              docObj.SenderId = obj.user[0].id;
              docObj.ReceiverId = attendeeId;
              docObj.CreatedDate = new Date();
              docObj.LastModifiedDate = new Date();
              if (obj.me) docObj.SenderTimeZone = moment.tz.guess();
              docObj.ReciverTimeZone = "";
              if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                Email = "vishalakshi.murthy@webspiders.com";
              }

              db.collection(obj.eventcollectionname)
                .doc("MeetingList")
                .collection("Meetings")
                .doc(MeetingId)
                .set(docObj)
                .then(function () {
                  // alert("Meeting Created Successfully");

                  var objEventName;
                  if (obj.eventname !== undefined) {
                    objEventName = obj.eventname;
                  } else {
                    objEventName = "";
                  }

                  //**** Start EMAIL Meeting Request To Receiver
                  //
                  var message;
                  if (
                    $("#MeetingPurpose").val() != "undefined" ||
                    $("#MeetingPurpose").val().toString().trim() != ""
                  ) {
                    message = $("#MeetingPurpose").val();
                  } else {
                    message = "N/A";
                  }

                  var Meetingurl =
                    "https://" + location.host.toLowerCase() + "/mymeetings";

                  var htmlmailbody1 = self.ReceivedMeetingEmailHtml(
                    obj.user[0].name,
                    attendeeName,
                    obj.user[0].title,
                    obj.user[0].company,
                    obj.user[0].Email,
                    MeetingStartDate,
                    message,
                    Meetingurl,
                    obj.client[0].name
                  );

                  var requestData1 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: attendeeName,
                      email: Email,
                    },
                    subject:
                      "You have received a meeting request from " +
                      obj.user[0].fname,
                    html: htmlmailbody1,
                  };

                  self.SentMeetingMail(requestData1);

                  self.SentMeetingNotification(
                    "newrequest",
                    obj.user[0].name,
                    obj.user[0].profilepic != "" ? obj.user[0].profilepic : "",
                    attendeeId
                  );

                  //**** End EMAIL Meeting Request To Receiver

                  //**** Start EMAIL To Meeting Sender

                  let htmlmailbody2 = self.RequestMeetingEmailHtml(
                    attendeeName,
                    obj.user[0].name,
                    Title,
                    Company,
                    Email,
                    MeetingStartDate,
                    message,
                    Meetingurl,
                    obj.client[0].name
                  );
                  var requestData2 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: obj.user[0].name,
                      email: obj.user[0].Email,
                    },
                    subject:
                      "You have requested for a meeting with " + attendeeName,
                    html: htmlmailbody2,
                  };

                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    requestData2.to.email = "vishalakshi.murthy@webspiders.com";
                  }

                  self.SentMeetingMail(requestData2);

                  // var attendeeNameData = attendeeName.split(" ");
                  // var attendeeFName = parseInt(attendeeNameData[0]);
                  // var attendeeLName = parseInt(attendeeNameData[1]);

                  // self.SentMeetingNotification(
                  //   "newrequest",
                  //   attendeeName,
                  //   attendeeFName,
                  //   attendeeLName,
                  //   Image,
                  //   obj.user[0].id);

                  //**** End EMAIL EMAIL To Meeting Sender

                  this.showDatePicker = true;
                  $(".modal-dialog.xl").addClass("success");
                  $(".calendar-wrap").hide();
                  $(".modal-body-wrapper2").hide();
                  $(".modal-body-wrapper3").show();
                  $("#btnSendRequest").attr("disabled", false);
                  $("#btnSendRequest").text("Send Request");
                })
                .catch(function (error) {
                  console.error("Error creating Meeting: ", error);
                });
            } else {
              //
              db.collection(obj.eventcollectionname)
                .doc("Meetings")
                .collection("AllMeetings")
                .doc(MeetingId)
                .update({
                  AttendeeId: attendeeId,
                  MeetingType: MeetingType,
                  AttendeeName: attendeeName,
                  Initials: Initials,
                  Company: Company,
                  Title: Title,
                  Email: Email,
                  Phone: Phone,
                  Image: Image,
                  OrganizerAttendees: obj.user[0],
                  Subject: "One to One Meeting with " + obj.user[0].name,
                  location: "",
                  StartDateTime: MeetingStartDate,
                  EndDateTime: MeetingEndDate,
                  Message: $("#MeetingPurpose").val(),
                  Status: "Pending",
                  LastModifiedDate: new Date(),
                  SenderTimeZone: moment.tz.guess(),
                  ReciverTimeZone: "",
                })
                .then(function () {
                  console.log("Meeting Updated : " + MeetingId);

                  this.showDatePicker = true;
                  $(".modal-dialog.xl").addClass("success");
                  $(".calendar-wrap").hide();
                  $(".modal-body-wrapper2").hide();
                  $(".modal-body-wrapper3").show();
                })
                .catch(function (error) {
                  console.error("Error updating Meeting: ", error);
                });
            }
          })
          .catch(function (error) {
            console.log("Error saving Meeting:", error);
          });
      }
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    formatDate: function (date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    RequestMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Title,
      Company,
      Email,
      dStartDateTime,
      message,
      Meetingurl,
      ClientName
    ) {
      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>You have requested for the below meeting:</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }
      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>When</td>";
      htmlmailbody += "<td>" + dStartDateTime + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>To check the status of your meeting request</p>";
      htmlmailbody +=
        "<p>Visit <a href='" + Meetingurl + "'>" + Meetingurl + "</a></p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    ReceivedMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Title,
      Company,
      Email,
      dStartDateTime,
      message,
      Meetingurl,
      ClientName
    ) {
      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>You have received a new meeting request:</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }
      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>When</td>";
      htmlmailbody += "<td>" + dStartDateTime + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody +=
        "<p>Visit <a href='" +
        Meetingurl +
        "'>" +
        Meetingurl +
        "</a> to check the status of all your meetings.</p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    SentMeetingMail: function (EMailObj) {
      console.log(JSON.stringify(EMailObj));

      let headers = {
        "Content-Type": "application/json",
      };
      axios
        .post(self.EmailURL, JSON.stringify(EMailObj), {
          headers: headers,
        })
        .then((data) => {
          if (data) {
            console.log(JSON.stringify(data));
          } else {
            console.log("null");
          }
        })
        .catch((error) => {
          console.log("Error in mail Sent", error);
        });
    },
    getInitials: function (str) {
      // alert(str);
      //var str = "Java Script Object Notation";
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = "";
      if (matches != null) {
        acronym = matches.join(""); // JSON
      }
      return acronym;
      //console.log(acronym);
    },
    LoadAttendeeDetails: function (attendeeId) {
      //alert(attendeeId);
      if (attendeeId) {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj.eventcollectionname) {
          db.collection(obj.eventcollectionname)
            .doc("AttendeeList")
            .collection("Attendees")
            .doc(attendeeId)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                //alert("success");
                var data = doc.data();

                self.attendeeProfile = data.Profile;
                self.attendeeRegType = data.RegistrationType;
                self.attendeeDynamicFields = data.DynamicFields;
              }
            })
            .catch(function (error) {
              //alert("error");
              console.log("Error loading attendees: ", error);
            });
        }
      }
    },
    SentMeetingNotification: function (
      type,
      SenderName,
      SenderProfilePictureURL,
      ReceiverId
    ) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var objEventName;
      if (obj.eventname !== undefined) {
        objEventName = obj.eventname;
      } else {
        objEventName = "";
      }

      var Meetingurl = location.host.toLowerCase() + "/mymeetings";
      var vardeviceToken = "";
      var varFirebaseServerKey = "";
      var NotificationSettings = [];

      var docMSRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Settings")
        .doc("MeetingSettings");

      docMSRef.get().then(function (doc) {
        if (doc.exists) {
          var MObj = new Object();
          MObj.NotificationMessage = doc.data().NotificationMessage;
          NotificationSettings.push(MObj.NotificationMessage);
          //

          var message;
          var messageName;
          var notifybefore;
          var NotifyTypeIndex;
          var PushNotificationIcon = "/images/success.png";

          if (type == "newrequest") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][1].Message.replace(
                "{{MeetingRequestor}}",
                SenderName
              );

              messageName = NotificationSettings[0][1].Name;
              NotifyTypeIndex = 1;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }
          if (type == "joined") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][2].Message.replace(
                "{{MeetingJoinee}}",
                SenderName
              ).replace("{{MyMeetings}}", Meetingurl);

              messageName = NotificationSettings[0][2].Name;
              NotifyTypeIndex = 2;
              notifybefore = 30;
              PushNotificationIcon = "/images/started.png";
            }
          }

          if (type == "cancelled") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][3].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );
              messageName = NotificationSettings[0][3].Name;
              NotifyTypeIndex = 3;
              notifybefore = 30;
              PushNotificationIcon = "/images/declined.png";
            }
          }

          if (type == "accepted") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][4].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );

              messageName = NotificationSettings[0][4].Name;
              NotifyTypeIndex = 4;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }

          var NotificationsId = ReceiverId + "_" + new Date().getTime();

          var MdocRef = db
            .collection(obj.eventcollectionname)
            .doc("AttendeeList")
            .collection("Attendees")
            .doc(ReceiverId)
            .collection("Notifications")
            .doc(NotificationsId);
          //
          MdocRef.get()
            .then(function (doc) {
              if (!doc.exists) {
                var docObj = new Object();
                docObj.Name = SenderName;
                docObj.Initials = self.getInitials(SenderName);
                docObj.ProfilePictureURL = SenderProfilePictureURL;
                docObj.Message = message;
                docObj.Title = messageName;
                docObj.NotifyTypeIndex = NotifyTypeIndex;
                docObj.Module = "Meeting";
                docObj.Time = new Date();
                docObj.ExpireInMinutes = notifybefore;
                docObj.isSeen = "0";
                docObj.CreatedDate = new Date();
                docObj.LastModifiedDate = new Date();

                MdocRef.set(docObj)
                  .then(function () {
                    console.log("Attendees Notifications Created ");

                    //**** Start web push
                    var docNRef = db
                      .collection(obj.eventcollectionname)
                      .doc("SubscribersList")
                      .collection("Subscriptions")
                      .doc(ReceiverId);

                    docNRef.get().then(function (doc) {
                      if (doc.exists) {
                        vardeviceToken = doc.data().DeviceToken;

                        db.collection("OA_UAT")
                          .doc("GeneralSettings")
                          .get()
                          .then(function (doc) {
                            if (doc.exists) {
                              varFirebaseServerKey =
                                doc.data().FirebaseServerKey;

                              console.log(varFirebaseServerKey);

                              let headers = {
                                Authorization: "key=" + varFirebaseServerKey,
                              };
                              axios
                                .post(
                                  self.FCMURL,
                                  JSON.stringify({
                                    to: vardeviceToken,
                                    notification: {
                                      title: objEventName + ": " + messageName,
                                      body: message,
                                      icon: PushNotificationIcon,
                                    },
                                  }),
                                  {
                                    headers: headers,
                                  }
                                )
                                .then((response) => {
                                  console.log(
                                    "PushNotifications respone: ",
                                    response
                                  );
                                })
                                .catch((error) => {
                                  console.log(
                                    "Error PushNotifications : ",
                                    error
                                  );
                                });
                            }
                          });
                      }
                    });
                    //**** End web push
                  })
                  .catch(function (error) {
                    console.error("Error AttendeesNotifications : ", error);
                  });
              }
            })
            .catch(function (error) {
              console.error("Error creating AttendeesNotifications: ", error);
            });
        }
      });
    },
    setFirebaseAppsettings: function () {
      //
      var docRefGeneralSettings = db
        .collection("OA_UAT")
        .doc("GeneralSettings");
      docRefGeneralSettings.get().then(function (doc) {
        if (doc.exists) {
          self.EmailURL = doc.data().EmailURL;
        }
      });
    },
    fetchSlots: function (SelectedDt) {
      console.log("Lv1");
      $(".datepicker-day").removeClass("selected");
      $("#show-lable").show();
      $("#slotUL").hide();
      $("#slotUL").empty();
      self.availableSlot = [];
      self.SlotAvailable = [];
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      var frDate = moment(SelectedDt).format("YYYY-MM-DD" + " 00:00:00Z");
      var toDate = moment(SelectedDt).format("YYYY-MM-DD" + " 23:59:59Z");
      if (self.attendee) {
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: obj.client[0].id,
            eventId: obj.eventid,
          },
          // data: {
          //   dateStr: moment(SelectedDt, ["YYYY-MM-DD"]).format("YYYY-MM-DD")
          // }
          data: {
            fromDateStr: moment(frDate).utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
            toDateStr: moment(toDate).utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
            attendeeId:
              $("#hdnAttendeeId").val() != undefined
                ? $("#hdnAttendeeId").val()
                : self.attendee.AttendeeId,
          },
        };
        axios
          .post(
            self.APIs.MeetingAPIConfig.GetMeetingSlot,
            JSON.stringify(requestData),
            {
              headers: headers,
            }
          )
          .then((response) => {
            debugger;
            console.log(response);
            var res = response.data;
            var arrSlots = res.slots;

            if (arrSlots) {
              arrSlots = arrSlots.sort(function compare(a, b) {
                var dateA = parseInt(new Date(a).getTime() / 1000);
                var dateB = parseInt(new Date(b).getTime() / 1000);
                return dateA - dateB;
              });

              var cnt = 0;
              let i;
              for (i = 0; i <= arrSlots.length - 1; i++) {
                cnt += 1;

                var btnslotId = "btnslot" + cnt;
                var strSoltTime = moment
                  .tz(arrSlots[i], "UTC")
                  .tz(moment.tz.guess())
                  .format("hh:mm A");
                // var strSoltTime = moment(res.slots[i], [
                //   "YYYY-MM-DD'T'HH:mm:ss.SSS'Z'",
                // ]).format("hh:mm A");
                //console.log(moment.tz(arrSlots[i], 'UTC').tz(moment.tz.guess()).format("DD-MM-YYYY") +" == "+ moment(SelectedDt).format("DD-MM-YYYY"))
                if (
                  moment
                    .tz(arrSlots[i], "UTC")
                    .tz(moment.tz.guess())
                    .format("DD-MM-YYYY") ==
                  moment(SelectedDt).format("DD-MM-YYYY")
                ) {
                  var timeStatus = self.checkDate(SelectedDt, strSoltTime);
                  if (timeStatus === true) {
                    $("#slotUL").append(
                      "<li><button id='" +
                        btnslotId +
                        '\' class="clsbtnSlot active_time">' +
                        strSoltTime +
                        "</button></li>"
                    );
                  } else {
                    $("#slotUL").append(
                      "<li><button disabled='true' id='" +
                        btnslotId +
                        '\' class="clsbtnSlot active_time disable-slot">' +
                        strSoltTime +
                        "</button></li>"
                    );
                  }

                  self.SlotAvailable.push(
                    moment
                      .tz(res.slots[i], "UTC")
                      .tz(moment.tz.guess())
                      .format("hh:mm A")
                  );
                }
              }
            }

            if (self.attendee && self.attendee.AttendeeId) {
              $("#calendarModal").modal("show");
            }

            setTimeout(() => {
              $(".clsbtnSlot").each(function () {
                var dynamic_value = function () {
                  self.OpenMeetingDetails(SelectedDt, this.innerHTML);
                };
                this.addEventListener("click", dynamic_value);
              });
            }, 400);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    RequestMeeting: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var SelDateTime = $("#hdnSelectedDate").val();
      //var dtStartDateTime = new Date(SelDateTime);

      //  moment(res.slots[i], ["YYYY-MM-DD'T'HH:mm:ss.SSS'Z'"]).format(
      //                   "hh:mm A"
      //                 );
      //momentDate.format('YYYY-MM-DDTHH:mm:ss') + '00:00';

      var MeetingStartDate = moment(SelDateTime)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      //MeetingStartDate = new Date(MeetingStartDate);

      // var MeetingEndDate = moment(dtStartDateTime, ["h:mm A"]).add(
      //   self.MeetingSettings.Slot,
      //   "minutes"
      // );
      // MeetingEndDate = new Date(MeetingEndDate);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          RequestorId: obj.UserID,
          InviteeId:
            $("#hdnAttendeeId").val() != undefined
              ? $("#hdnAttendeeId").val()
              : self.attendee.AttendeeId,
          Slots: [MeetingStartDate],
          MeetingType: "one2one",
          Subject: "One to One Meeting with " + obj.user[0].name,
          Message: $("#MeetingPurpose").val(),
          Status: "Pending",
          RequestorTimezone: moment.tz.guess(),
          InviteeTimezone: "",
          Timezone: obj.tzone,
          Phone: this.formatedPhoneNo,
        },
      };
      $("#btnSendRequest").attr("disabled", true);
      $("#btnSendRequest").text("Sending Request");
      axios
        .post(
          self.APIs.MeetingAPIConfig.RequestMeeting,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data) {
            if (response.data.status == 0) {
              self.showSnackbar(
                "Meeting request sent successfully",
                "info",
                "top"
              );
            } else if (response.data.status == -13) {
              self.showSnackbar(
                "There is a meeting booked already in this time slot! ",
                "error",
                "top"
              );
            } else {
              self.showSnackbar(response.data.msg, "error", "top");
            }
          }
          this.postLeaderboardAction("O2OB");
          this.showDatePicker = true;
          $(".modal-dialog.xl").addClass("success");
          $(".calendar-wrap").hide();
          $(".modal-body-wrapper2").hide();
          $(".modal-body-wrapper3").show();
          console.log(response);
          this.formatedPhoneNo = null;
        })
        .catch((error) => {
          $(".calendar-wrap").hide();
          $(".modal-body-wrapper2").hide();
          $(".modal-body-wrapper3").show();
          $("#btnSendRequest").text("Send Request");
          $("#btnSendRequest").attr("disabled", false);
          console.log(error);
        });
    },
    showPayload(payload) {
      this.formatedPhoneNo = payload.formatInternational;
    },
    clearModal() {
      $("#MeetingPurpose").val("");
      this.phoneNo = null;
    },
  },
};
</script>
